export default {"src":"/_next/static/media/dots-own.f1be195d.svg","height":100,"width":100};